import { ref } from 'vue'

/**
 * Aprovar folha com linha sem correspondência na conciliação (web#2336,
 * minhaescala-product#81, opção B): não bloqueia mais, pede confirmação. O
 * backend já aceita aprovar com linha DIVERGENT; ela fica registrada na folha e
 * não gera check no plantão.
 */
/** Linha da folha: colunas da transcrição mais a coluna de conciliação, quando já conciliada. */
type ConciliatedRow = { conciliation?: unknown; [column: string]: unknown }

const APPROVED = 'APROVADO'

/** Linhas que a conciliação marcou como "Sem correspondência" (warning). */
export function countUnmatchedRows(rows: ConciliatedRow[]): number {
  return rows.filter(
    (row) => (row.conciliation as { type?: string } | undefined)?.type === 'warning'
  ).length
}

/** Só "Aprovada" com ao menos uma linha sem correspondência pede confirmação. */
export function needsUnmatchedConfirmation(status: string | null, unmatchedCount: number): boolean {
  return status === APPROVED && unmatchedCount > 0
}

export function unmatchedRowsMessage(count: number): string {
  return count === 1
    ? '1 linha da folha está sem correspondência com plantão.'
    : `${count} linhas da folha estão sem correspondência com plantão.`
}

/**
 * Segura a aprovação até o auditor confirmar. A última tentativa é a que vale:
 * quem confirma aprova o que pediu por último (salvar ou aprovar e abrir o próximo).
 */
export function useUnmatchedApprovalGate() {
  const isOpen = ref(false)
  let pending: (() => unknown) | null = null

  function guard(status: string | null, unmatchedCount: number, proceed: () => unknown): void {
    if (!needsUnmatchedConfirmation(status, unmatchedCount)) {
      proceed()
      return
    }
    pending = proceed
    isOpen.value = true
  }

  function confirm(): void {
    const proceed = pending
    pending = null
    isOpen.value = false
    proceed?.()
  }

  function cancel(): void {
    pending = null
    isOpen.value = false
  }

  return { isOpen, guard, confirm, cancel }
}
